module.exports = __webpack_public_path__ + "static/media/Exclusion 2.f41c5ba9.svg";